import { nameRegex } from "./Helper";

export const validateName = (
  name: string,
  nameType: "first" | "last"
): string => {
  if (name.trim().length === 0) {
    if (nameType === "first") return "Please enter your first name";
    if (nameType === "last") return "Please enter your last name";
  } else if (!nameRegex.test(name.trim())) {
    return "Enter characters only";
  }
  return "";
};


